export enum ReservationsListActions {
  SetSorOrder = 'set reservatons list sort order',
  SetDate = 'set reservatons list date',
  SetReservations = 'set reservations list events',
  LoadList = 'load reservation list',
  SetSearch = 'set reservations list search',
}
